import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { Intent, Button } from "@blueprintjs/core";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISplitButtonProps extends ICustomButtonProps {}

export const SplitButton: React.FunctionComponent<ISplitButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.FORK}
      minimal={minimal}
      onClick={onClick}
      text={text || (minimal ? null : t(ETLCodes.General_Split))}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={onClick ? "button" : "submit"}
    />
  );
};
